import Reveal from "@/components/site/Reveal";
import SectionTitle from "@/components/site/SectionTitle";
import SiteButton from "@/components/site/SiteButton";

interface HowItWorksSectionProps {
  onRequest: () => void;
}

const steps = [
  {
    title: "Vous faites la demande",
    text: "Le formulaire prend cinq minutes : votre école, ses cycles, le forfait voulu et la personne à contacter. Vous recevez une référence pour suivre la demande.",
  },
  {
    title: "Nous ouvrons votre espace",
    text: "Nous vérifions la demande, puis créons votre école. Le directeur reçoit ses identifiants et choisit son mot de passe à la première connexion.",
  },
  {
    title: "Vous préparez l'année",
    text: "Ouvrez vos cycles, créez vos classes, remplissez la fiche des frais et donnez un accès à chaque membre de l'équipe.",
  },
  {
    title: "Vous travaillez au quotidien",
    text: "Inscriptions, paiements, notes et caisse se font dans la même application. Les documents sortent en PDF.",
  },
];

export default function HowItWorksSection({ onRequest }: HowItWorksSectionProps) {
  return (
    <section id="etapes" className="scroll-mt-28 bg-white py-20 md:py-28">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <SectionTitle eyebrow="Démarrer" title="De la demande à la rentrée, en quatre étapes" />

        <ol className="relative mt-14 grid gap-10 md:grid-cols-4 md:gap-6">
          {/* Fil de la frise (ordinateur). */}
          <span className="absolute left-0 right-0 top-6 hidden h-px bg-background-300 md:block" aria-hidden="true"></span>
          {steps.map((step, index) => (
            <Reveal key={step.title} delay={index * 90}>
              <li className="relative flex gap-4 md:block">
                <span className="relative z-10 flex h-12 w-12 shrink-0 items-center justify-center rounded-full border-4 border-white bg-primary-950 text-lg font-bold font-heading text-white">
                  {index + 1}
                </span>
                <div className="md:mt-5">
                  <h3 className="text-lg font-bold font-heading text-foreground-950">{step.title}</h3>
                  <p className="mt-2 text-[0.95rem] leading-relaxed text-foreground-600">{step.text}</p>
                </div>
              </li>
            </Reveal>
          ))}
        </ol>

        <div className="mt-12 flex flex-col items-start gap-4 rounded-[1.5rem] bg-primary-50 p-6 sm:flex-row sm:items-center sm:justify-between md:p-8">
          <p className="max-w-xl text-foreground-800">
            Vous avez déjà fait une demande ? Gardez votre référence <span className="font-semibold">DEM-…</span> : elle
            suffit pour savoir où elle en est.
          </p>
          <div className="flex flex-wrap gap-2">
            <SiteButton variant="outline" to="/suivre-demande" icon="ri-route-line">
              Suivre ma demande
            </SiteButton>
            <SiteButton onClick={onRequest}>Faire une demande</SiteButton>
          </div>
        </div>
      </div>
    </section>
  );
}
